import { Injectable, signal } from '@angular/core';
import { ToastNotifications } from './toast-notifications.datamodel';

@Injectable()
export class ToastNotificationsService {
  readonly notifications = signal<ToastNotifications[]>([]);

  /**
   * Add a new toast notification to the list
   * @param notification
   */
  showToast(notification: ToastNotifications): void {
    this.notifications.update((previous) => ([...previous, notification]));
  }

  /**
   * Remove the latest toast notification from the list
   */
  removeOldest(): void {
    this.notifications.update((previous) => previous.slice(1));
  }
}
